import { NgRedux } from '@angular-redux/store';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { IAppState } from 'src/app/shared/state-management/state-interfaces';
import { IUser } from 'src/app/user-management/user-management-interfaces';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';
@Component({
  selector: 'app-device-users',
  templateUrl: './device-users.component.html',
  styleUrls: ['./device-users.component.scss'],
})
export class DeviceUsersComponent {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  formGroup!: FormGroup;
  readonly LANG_CONST = LANG_CONST;
  submited: boolean = false;
  @Input() userList!: IUser[] | undefined;

  constructor() {}

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper = 1));
  }
}
